export enum TransferStrings {
  // Page Titles
  TransferRequestList = 'CH5O',
  ItemList = 'aHZ0',
  SelectedItemsForTransfer = 'Bx9k',

  // Column Headers
  TransferId = 'xriA',
  To = '9LBu',
  ToUppercase = 'w719',
  From = 'IYGX',
  FromUppercase = '9Dg8',
  Requester = 'tWh8',
  Status = 'kg5B',
  StatusUppercase = 'jC5K',
  TransferUnit = 'Nsvd',
  QtyRequested = 'FWH/',

  // Labels
  EnterQtyRequested = 'khJM',
  ShowingItems = '12+W',

  // Buttons
  NewRequest = 'xkjT',
  Refresh = 'DpFh',
  View = '3Mg5',
  Send = '9vRo',
  ClearQtyRequested = 'FjeM',
  ClearAllQtyRequested = 'y4/P',
  Edit = 'eXNh',
  SendRequest = 'Mmow',
  CancelTransfer = '8IDL',

  // Messages
  SendThisTransferRequest = 'VQIG',
  CancelThisTransferRequest = '5iqv',
  FailedToSendTransferByNoItem = 'kYJj',
  FailedToUpdateTransferByDmSync = '22Xf',
  FromSiteCannotBeSameAsToSite = 'ASFb',
  ChangeSite = 'wFa1',
  TransferUnitTips = 'qVAQ',
  Leave = 'rxkx',
  RequestSentSuccessfully = 'kRkf',
  CanceledSuccessfully = 'SyTq',

  // Dynamic Messages
  ConfirmToUpdateTransfer = 'RF5X',
  FailedToUpdateTransfers = 'XTSk',
  UpdateTransfersSuccessfully = 'aQ0A',

  // Action Words (lowercase for use in messages)
  ActionCancel = 'P4Zw',
  ActionCanceled = 'E8ou',
  ActionCanceledLowercase = '8S/e',
  ActionSend = 'tLmN',
  ActionSent = 'wWvI',
  ActionSentLowercase = 'evuz',

  // Transfer Status Names
  StatusNew = 'qyg2',
  StatusOpenDraft = 'HSmw',
  StatusOpen = 'YT2U',
  StatusPending = 'O/Iy',
  StatusCompleted = '7Hyu',
  StatusVoid = 'I1dt',
  StatusRejected = 'fVaO',
  StatusNoStatus = 'tlzj',
}
